import { render, staticRenderFns } from "./declaracao_aproveitamento.vue?vue&type=template&id=0c9adcb3&"
import script from "./declaracao_aproveitamento.vue?vue&type=script&lang=js&"
export * from "./declaracao_aproveitamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports